import React from "react";
import Link from "../Link";
import group6 from "../../img/group-6-black.svg";
import right2 from "../../img/right@2x.svg";
import "./NonRegisteredButton.css";

const NonRegisteredButton = (props) => {
    const { className, handLogoNon } = props

    return (
        <Link href="/non-reg-page" >
            <div className="non-registered-button">
                <div className="non-registered-button-3">
                    <img className="group-3" src={`${handLogoNon || group6}`} />
                    <div className="overlap-group-77">
                        <img className="right-36" src={right2} />
                        <div className={`non-registered ${className || "nunito-bold-black-14px"}`}>Non Registered</div>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default NonRegisteredButton;